// extracted by mini-css-extract-plugin
export var active = "_35-7";
export var container = "_35-0";
export var evenWidth = "_35-4";
export var large = "_35-5";
export var outlet = "_35-8";
export var slide = "_35-2";
export var small = "_35-6";
export var tab = "_35-3";
export var tabs = "_35-1";